import { login } from '@/api/login'
// import { role } from '../../utils/roles'
import { getToken, setToken, removeToken } from '@/utils/auth'
let _userInfo = localStorage.getItem('userInfo')

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    userInfo: _userInfo ? JSON.parse(_userInfo) : {},
    goodsImg: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USER: (state, data) => {
      state.userInfo = data
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_IMG: (state, goodsImg) => {
      state.goodsImg = goodsImg
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const tokenStr = response.data.token
          const userName = response.data.name
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          commit('SET_NAME', userName)

          // 用户权限
          let _user = response.data
          _user.permission = []

          // _user.permission = role[_user.role_key].role
          // if (_user.role[0] == 'all') {
          //   _user.permission = []
          // }
    
          // if (_user.purview) {
          //   _user.permission = JSON.parse(_user.purview)
          // }
          localStorage.setItem('userInfo', JSON.stringify(_user))
          commit('SET_USER', _user)


          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js